import { createAction, props } from '@ngrx/store';
import { Profile } from '../../models/profile';
import { ServerMessage } from '../../models/server-message';

export const profileInitialize = createAction(
    '[Startup] Initialize Profile'
);

export const profileRequest = createAction(
    '[Profile] Request Profile',
    props<{ useCache: boolean }>()
);

export const profileReceived = createAction(
    '[Profile] Received Profile',
    props<{ profile: Profile }>()
);

export const profileReload = createAction(
    '[Profile] Request Reload'
);

export const profileFailure = createAction(
    '[Profile] Request Failed'
);

export const profileClearCache = createAction(
    '[Profile] Clear Cache'
);

export const profileSelectTheme = createAction(
    '[Profile] Select Theme',
    props<{ name: string }>()
);

export const profileSelectIcons = createAction(
    '[Profile] Select Icon Set',
    props<{ name: string }>()
);

export const profileSubmitSetting = createAction(
    '[Profile] Submit setting change',
    props<{ id: string, value: any }>()
);

export const profileSettingUpdated = createAction(
    '[Profile] Updated Setting Received',
    props<{ id: string, value: any }>()
);

export const profileSettingFailed = createAction(
    '[Profile] Error Updating Setting',
    props<{ error: ServerMessage[] }>()
);

export const profileCheckValidity = createAction(
    '[Profile] Check for Profile Expiry'
);

export const profileEdit = createAction(
    '[Profile] User Edit Request',
);

export const profileTermsAgreed = createAction(
    '[Profile] Agreed to Terms',
    props<{ id: string }>()
);
